class Letter {

  constructor(id, latin, arabic, name, sound) {
    this.id = id
    this.latin = latin
    this.arabic = arabic
    this.name = name
    this.sound = sound
  }
  getID() {
    return this.id
  }
  getLatin() {
    return this.latin
  }
  getArabic() {
    return this.arabic
  }
  getName() {
    return this.name
  }
  getForm(form) {
    form = parseInt(form)
    if (form === 4) { // For returning a random letter form.
      form = Math.floor(Math.random() * 3)
    }
    if (form === 0 || form === "isolated") {
      return " " + this.arabic + " "
    } else if (form === 1 || form === "initial") {
      return `${this.arabic}د`
    } else if (form === 2 || form === "medial") {
      return `ن${this.arabic}ا`
    } else if (form === 3 || form === "final") {
      return `ن${this.arabic}`
    } else {
  //    throw "No form requested."
  return "Error"
    }
  }
  equals(other) {
    if (other === null) return false
    return other.arabic === this.arabic || other.latin === this.latin
  }
}

export default Letter
